import { useEffect, useState } from "react"
import { vision } from "../../services/resultsService";
import { Step } from "../../components/Step/ResultsStep";
import { NextButtonBlack } from "../../components/Buttons/NextButtonBlack";

export const ResultsVision = () => {
    const [hasPaid, setHasPaid] = useState(false);
    const [content, setContent] = useState({
        statement: 'Vision Statement.',
        paragraph: 'Content is being loaded.'
    });
    const [isLoading, setIsLoading] = useState(true);

    const [companyName, setCompanyName] = useState('Your Company');

    const header = {
        index: "02",
        section: "Vision",
        company: companyName
    }

    useEffect(() => {
        vision().then(response => {
            const { vision, company } = response.data;
            if (vision) {
                setContent(JSON.parse(vision));
                setHasPaid(true);
            }
            company ? setCompanyName(company) : setCompanyName('Your Company');
        }).catch(err => {
            const status = err.response.status;
            setIsLoading(false);
            if (status === 403) {
                setHasPaid(false);
            }
        });
    }, []);

    const handleClick = () => {
        window.location.href = "/flow/checkout"
    }

    return (
        <Step header={header}>
            {hasPaid ? (
                <>
            <h1 className="results__title">
                {content.statement}
            </h1>
            <p className="results__description">
                {content.paragraph}
            </p>
            </>
            ) : (
                <>
                    <h1 className="results__title statement__paidText" style={{ textShadow: "0px 0px 30px rgb(255 255 255)" }}>
                        {content.statement}
                    </h1>
                    <h2 className="results__subtitle statement__paidText" style={{ textShadow: "0px 0px 10px rgb(255 255 255)", color: "transparent" }}>
                        {content.secondaryStatement}
                    </h2>
                    <p className="results__description statement__paidText" style={{ textShadow: "0px 0px 10px rgb(255 255 255)", color: "transparent" }}>
                        {content.paragraph}
                    </p>
                    {!isLoading && (
                        <div className="flex gap-8 items-center">
                            <p className="results__description" style={{ width: 'max-content' }}>
                                Please complete payment in order to view <br /> the vision statement and the associated description.
                            </p>
                            <button className="btn prev" onClick={handleClick}>
                                <NextButtonBlack isYellow />
                            </button>
                        </div>
                    )}
                </>
            )}
        </Step>
    )
}